import React, { useEffect } from "react";
import Barcode from "react-barcode";

import { ROUTES } from "features/Users/Addresses";

import "./printRouteSheet.scss";


export const PrintRouteSheet = ({ routeSheet }) => {

  useEffect(() => {
    setTimeout(() => {
      window.print();
    }, 200);
  }, []);

  return (
    <>
      <style>
        {`@media print {
            @page {
              size: A4 landscape;
              margin: 0;
				    }}
          }`
        }
      </style>

      <div className="printRouteSheet">
        <div className="d-flex justify-content-between">
          <div>№{routeSheet.number}</div>
          <div><Barcode height={40} fontSize={10} value={`R${routeSheet.number}`} format="CODE128" className="ml-2" /></div>
        </div>
        <table>
          <thead>
            <tr>
              <th>
                <b>{routeSheet.driver}</b>
              </th>
              <th>
                № заказа
              </th>
              <th>
                Мест
              </th>
              <th>
                Пал-т
              </th>
              <th>
                М-т
              </th>
              <th>
                Адрес
              </th>
              <th>
                Город
              </th>
              <th>
                Трансп комп
              </th>
              <th>
                Время работы
              </th>
              <th>
                Контакт получателя
              </th>
              <th>
                Плательщик
              </th>
              <th>
                ФИО менеджера
              </th>
              <th>
                Комментарий к отгрузке
              </th>
            </tr>
          </thead>
          <tbody>
            {routeSheet.delivery.map(delivery =>
              <>{delivery.customers.map(customer =>
                <tr>
                  <td className="customer">
                    {customer.customer}
                  </td>
                  <td>
                    {customer.orders.map(order => <div>№{order.number}</div>)}
                  </td>
                  <td>
                    {customer.orders.map(order => <div>{order.quantityLabels}</div>)}
                  </td>
                  <td>
                    {customer.orders.map(order => <div>{order.quantityPallets}</div>)}
                  </td>
                  <td>
                    {ROUTES.find(v => v.value === delivery.route)?.shortName}
                  </td>
                  <td>
                    {delivery.address}
                  </td>
                  <td>
                    {delivery.city}
                  </td>
                  <td>
                    {delivery.transportCompany}
                  </td>
                  <td>
                    {delivery.workingHours}
                  </td>
                  <td>
                    {customer.contact}
                  </td>
                  <td>
                    {delivery.address?.senderIsPayer ? "ООО ЛИДЕР ТРАК" : customer.customer}
                  </td>
                  <td>
                    {customer.admins.map(order => <div>{order.admin} {order.phone} </div>)}
                  </td>
                  <td>
                    {customer.comment}
                  </td>
                </tr>
              )}</>
            )}
          </tbody>
        </table>
        <div className="mt-5">
          <p>Загрузил (ФИО): _________________________________________________________</p>
          <p>Получил (ФИО): __________________________________________________________</p>
        </div>
      </div>
    </>
  );
};